module.exports = __webpack_public_path__ + "static/media/union1.1a14b4f6.png";